export const DASHBOARD_ACCESS_KEY = 'dashboardAccess';
export const DASHBOARD_ACCESS_EVENT = 'dashboard-access-enabled';

export const hasDashboardAccess = () => localStorage.getItem(DASHBOARD_ACCESS_KEY) === 'enabled';

export const enableDashboardAccess = () => {
  localStorage.setItem(DASHBOARD_ACCESS_KEY, 'enabled');
  window.dispatchEvent(new Event(DASHBOARD_ACCESS_EVENT));
};
